import { Promo } from '@bonanza-social/promos';
import { RewardType } from '@bonanza-social/rewards';
import { formatCompact } from '@bonanza-social/toolkit/utils';
import { formatAmount } from '@bonanza-social/toolkit/utils';

export const aggregateRewards = (promos: Promo[]) =>
  Object.values(
    promos.reduce<
      Partial<
        Record<
          RewardType,
          {
            type: `${RewardType}`;
            amount: number;
          }
        >
      >
    >((accumulator, { rewards }) => {
      rewards.forEach(({ rewardTarget, rewardAmount }) => {
        if (rewardTarget === 'Bonus') {
          return;
        }

        if (accumulator[rewardTarget] === undefined) {
          accumulator[rewardTarget] = {
            type: rewardTarget,
            amount: 0,
          };
        }

        accumulator[rewardTarget].amount += rewardAmount;
      });

      return accumulator;
    }, {}),
  ).map(({ type, amount }) => ({
    type,
    amount: type === 'Coins' ? formatAmount(amount) : formatCompact(amount),
  }));
